// eslint-disable-next-line no-restricted-syntax
export enum ActiveTab {
  ACTIVE = 'ACTIVE',
  FINAL = 'FINAL',
}
